import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getTokens, logout } from '../auth/auth-middleware';
import { loadMe } from '../user/user-middleware';
import {
    clearPersistedSelectedAccount,
    getPersistedSelectedAccount,
    isSpouseAccount,
    persistSelectedAccount,
    resolveSelectedUserId,
} from 'utils/selectedAccount';

interface SelectedAccountState {
    selectedUserId: number | null;
}

const initialState: SelectedAccountState = {
    selectedUserId: getPersistedSelectedAccount()?.selectedUserId ?? null,
};

const selectedAccountSlice = createSlice({
    name: 'root/selectedAccount',
    initialState,
    reducers: {
        setSelectedUserId: {
            reducer: (state, action: PayloadAction<{ selectedUserId: number }>) => {
                state.selectedUserId = action.payload.selectedUserId;
            },
            prepare: ({
                ownerUserId,
                selectedUserId,
            }: {
                ownerUserId: number;
                selectedUserId: number;
            }) => {
                persistSelectedAccount(ownerUserId, selectedUserId);
                return { payload: { selectedUserId } };
            },
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadMe.fulfilled, (state, action) => {
                const me = action.payload.data;
                const spouse = isSpouseAccount(me.spouse) ? me.spouse : null;
                const persisted = getPersistedSelectedAccount();
                const persistedSelected =
                    persisted && persisted.ownerUserId === me.id ? persisted.selectedUserId : null;
                const selectedUserId = resolveSelectedUserId(me.id, spouse, persistedSelected);
                state.selectedUserId = selectedUserId || null;
                if (me.id && selectedUserId) {
                    persistSelectedAccount(me.id, selectedUserId);
                }
            })
            .addCase(getTokens.fulfilled, (state) => {
                state.selectedUserId = null;
                clearPersistedSelectedAccount();
            })
            .addCase(logout.fulfilled, (state) => {
                state.selectedUserId = null;
                clearPersistedSelectedAccount();
            });
    },
});

export const { setSelectedUserId } = selectedAccountSlice.actions;
export default selectedAccountSlice.reducer;
